import { colors } from '@dixa/tokens';

export const shadows = {
  outline: `0 0 0 2px ${colors.purple[300]}`,
};
